import assert from 'minimalistic-assert'

const ECDSA_RECOVERY_ID_BASE = 27
const ALLOWED_VALUES = new Set([27, 28])
const ALLOWED_VALUES_WITHOUT_BASE = new Set([0, 1])

/*
   @exodus/elliptic returns signatures that have a recoverParam that is either 0 or 1.
   In the literature this is called recovery id. To get the value of v (which is the full recovery param)
   a fixed offset of 27 is added. The value our asset libraries expect is a little all over the place, so we have
   to either remove or add the offset again, depending on where we pass it. This helper can be used to harden our
   methods to transform the recovery param to the format we expect, so consumers don't have to think about that.
   
   The recovery param is not strictly necessary to recover the public key,
   so in case we end up with a recovery param that is not 0 or 1, we return undefined
   */

export const normalizeRecoveryParam = (v, { includeBase = false } = {}) => {
  const { allowedValues, offset } = includeBase
    ? { allowedValues: ALLOWED_VALUES, offset: ECDSA_RECOVERY_ID_BASE }
    : { allowedValues: ALLOWED_VALUES_WITHOUT_BASE, offset: -ECDSA_RECOVERY_ID_BASE }

  if (allowedValues.has(v)) return v

  const param = v + offset
  assert(allowedValues.has(param), `Failed to normalize unexpected recoveryParam ${v}`)
  return param
}
